const stringifyError = (error) => typeof error === "object" ? Object.values(error).map((err) => typeof err === "object" ? JSON.stringify(err) : err).join("; ") : error;
export {
  stringifyError
};
//# sourceMappingURL=stringifyError.js.map
